import { Category, CategoryResponse } from 'ducks/categories'

export const parseCategoriesData = (data: CategoryResponse): Array<Category> | undefined => data.categories
